/**
 * PATH: packages/job-hub/src/jobs/qa/phonePage.ts
 * FILE_ID: JOBHUB-QA-PHONE-PAGE-002
 * PURPOSE: Public subpath for the phone Set Up / QA page signal.
 */
export { requestQaPhonePage } from '../tabs/job-qa/phone/qaPhonePage'
export type { QaPhonePage } from '../tabs/job-qa/phone/qaPhonePage'

export const QA_PHONE_TITLE_ACTIONS_SLOT_ID = 'qa-phone-title-actions'

/** Reused from: packages/job-hub/src/jobs/qa/phonePage.ts (requestQaPhonePage) */
export function requestQaPhoneSheet(id: 'select-qa') {
  window.dispatchEvent(new CustomEvent('qa-phone-open-sheet', { detail: { id } }))
}

export function requestQaPhoneInspection(id: string) {
  window.dispatchEvent(new CustomEvent('qa-phone-inspection-picked', { detail: { id } }))
}
